/* unplugin-vue-components disabled */import script from "./ManageSalses.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageSalses.vue?vue&type=script&setup=true&lang=js"

import "./ManageSalses.vue?vue&type=style&index=0&id=aeedf224&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aeedf224"]])

export default __exports__